import { FormBehavior } from './index';
import initialAssessmentTemplate from '../templates/initialassessment.json';

const today = () => new Date().toISOString().split('T')[0];

export const initialAssessmentBehavior: FormBehavior = {
  renderHeader: () => null,

  getTemplate: () => {
    return JSON.stringify(initialAssessmentTemplate);
  },

  getInitialData: (props) => {
    const { participant } = props;
    const fullName = participant?.name
      ? `${participant.name.firstName || ''} ${participant.name.lastName || ''}`.trim()
      : '';

    return {
      '*assessmentDate': today(),
      '*membername': fullName,
      '*mediCalID': participant?.cin || '',
    };
  },

  supportsAltTemplate: false,

  customActions: [],

  customLogic: {
    onBeforeCreate: (data) => data,
    onBeforeUpdate: (data) => data,
    onAfterLoad: (data) => data,
  },
};
